import gsap from 'gsap'
import {colors, isAllMobileDevices, updateDeltaOnScroll, winsize} from './bundle'

class Header{
    constructor(){
        this.header = document.querySelector('header')
        this.headerBg = this.header.querySelector('.header__bg')
        this.fillItems = this.header.querySelectorAll('.js-header-fill')
        this.strokeItems = this.header.querySelectorAll('.js-header-stroke')
        this.colorItems = this.header.querySelectorAll('.js-header-color')
        this.backgroundItems = this.header.querySelectorAll('.js-header-background')

        this.progressBarSpan = document.querySelector('.header-progress-bar span')


        //FeedVino
        // console.log(this.container)
        this.headerFeedVino = document.querySelector('.header-feed-vino')
        this.headerFeedVinoHeight = this.headerFeedVino.getBoundingClientRect().height
        this.headerFeedVinoWrapper = this.headerFeedVino.querySelector('.header-feed-vino__wrapper')        



        this.changeColorDuration = 1.2

        this.initEvents()

    }

    initEvents(){
        // console.log(winsize.height)
        this.updateDimensionsForProgressBar()
        window.addEventListener('resize', () => {
            this.updateDimensionsForProgressBar()
        })
        this.initColors()
        if(!this.header.classList.contains('header-bloccato')){
            // console.log('add')
            this.header.classList.add('active')
        }
        // if(isAllMobileDevices){
        //     let container = document.querySelector('#container')
        //     let limit = container.getBoundingClientRect().height
        //     let coeff = winsize.width / (limit - winsize.height)
        //     container.addEventListener('scroll', e => {
        //         // console.log(container.getBoundingClientRect())
        //         console.log(container.scrollTop)
        //         gsap.set(this.progressBarSpan, {
        //             width: (container.scrollTop) * coeff
        //         })
        //     })
        // }
    }

    updateDimensionsForProgressBar(){
        this.scrollableHeight = document.querySelector('#scrollable').getBoundingClientRect().height
        this.progessLimit = this.scrollableHeight - winsize.height
    }

    //!Viene chamata in bundle js al primo init e ad ogni cambio di layout verticale/orizzontale
    updateScroller(awdScrollUpdated){
        // alert('awd scrolllll')
        // if(!isAllMobileDevices){
            let awdScroll = awdScrollUpdated
            awdScroll.on('scroll', (instance) => {
                // console.log(instance)
                // alert(instance)
                this.updateProgressBar(instance)
                this.deltaDirection = updateDeltaOnScroll(instance)
                this.layoutDirection = document.querySelector('html').getAttribute('data-scroll-direction') || 'vertical'
                // console.log(awdScroll.direction)
                this.showHideHeader(instance)
            })
        // }
    }
    


    updateProgressBar(instance){
        let coeff = winsize.width / this.progessLimit
        // console.log('progerssLimit, ', this.progessLimit)
        // console.log('instance.scroll.y, ', instance.scroll.y)
        // console.log('this.scrollableHeight, ', this.scrollableHeight)
        this.scrollableHeight = document.querySelector('#scrollable').getBoundingClientRect().height
        this.progessLimit = this.scrollableHeight - winsize.height
        // let moltiplicatore = instance.scroll.y
        if(instance.scroll.y < 20){
            // moltiplicatore = 0
            gsap.set(this.progressBarSpan, {
                width: 0
            })            
        }
        else if(this.progessLimit - instance.scroll.y <= 50){
            // moltiplicatore = 
            gsap.set(this.progressBarSpan, {
                width: this.progessLimit * coeff
            })
        }
        else{
            
            gsap.set(this.progressBarSpan, {
                width: instance.scroll.y * coeff
            })
        }
    }

    initColors(){
        //update header elements color
        const bgPageColor = getComputedStyle(document.querySelector('body')).backgroundColor
        // console.log(bgPageColor)
        if(bgPageColor === colors.panna){
            this.toAlternativeColor()
        }
        else{
            this.toDefaultColor()
        }        
    }

    showHideHeader(instance){
        // console.log(this.deltaDirection)
        // console.log(instance.scroll.y)
        // console.log(this.layoutDirection)
        // console.log('show-hide header')
        if(this.layoutDirection === 'vertical'){
            // alert(instance.scroll.y)
            if (instance.scroll.y > 50){
                gsap.to(this.headerBg, {
                    opacity: 1,
                    duration: this.changeColorDuration
                })
            }
            else{
                gsap.to(this.headerBg, {
                    opacity: 0,
                    duration: this.changeColorDuration
                })
            }
            if (this.deltaDirection > 0 && instance.scroll.y > 20){
                // console.log('remove')
               this.header.classList.remove('active')
            } 
            else {
                if(!this.header.classList.contains('header-bloccato')){
                    // console.log('add')
                    this.header.classList.add('active')
                }
            }
        }
        else if(this.layoutDirection === 'horizontal'){
            // if (instance.scroll.x > 250){
            if (this.deltaDirection > 0 && instance.scroll.x > 20){
               this.header.classList.remove('active')
            } 
            else {
                if(!this.header.classList.contains('header-bloccato')){
                    this.header.classList.add('active')
                }
            }

        }
    }

    toDefaultColor() {
        gsap.to(this.headerBg,{
            duration: this.changeColorDuration,
        	backgroundColor: colors.greyDark
        })
        gsap.to(this.colorItems, {
            duration: this.changeColorDuration,
            color: colors.white
        })
        // gsap.to(this.colorItemReverse, {
        //     duration: this.changeColorDuration,
        //     color: colors.black
        // })
        gsap.to(this.backgroundItems, {
            duration: this.changeColorDuration,
            backgroundColor: colors.white
        })
        gsap.to(this.strokeItems, {
            duration: this.changeColorDuration,
            stroke: colors.white
        })
        gsap.to(this.fillItems, {
            duration: this.changeColorDuration,
            fill: colors.white
        })
    }

    toAlternativeColor() {

        gsap.to(this.headerBg,{
            duration: this.changeColorDuration,
        	backgroundColor: colors.panna
        })
        gsap.to(this.colorItems, {
            duration: this.changeColorDuration,
            color: colors.black
        })
        // gsap.to(this.colorItemReverse, {
        //     duration: this.changeColorDuration,
        //     color: colors.white
        // })
        gsap.to(this.backgroundItems, {
            duration: this.changeColorDuration,
            backgroundColor: colors.black
        })
        gsap.to(this.strokeItems, {
            duration: this.changeColorDuration,
            stroke: colors.black
        })
        gsap.to(this.fillItems, {
            duration: this.changeColorDuration,
            fill: colors.black
        })
    }    

    ajaxRiempiFeedVino(productId){
        // console.log(productId)
        return new Promise(resolve => {
            let formData = new FormData()
            let request = new XMLHttpRequest()
            let url = document.getElementById('uri').value + '/AJAX/header-feed-vino.php'
            formData.append('productId', productId)
            request.open('POST', url, true)
            request.send(formData)
            request.onreadystatechange = () => {
                if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                    document.querySelector('.header-feed-vino').innerHTML = request.response
                    resolve()
                }
            }
        })        
    }
    //Le funzioni di apertura e chiusura del feed vengono chiamate in bundle.js prima e dopo l'uscita dalla pagina prodotto
    chiudiHeaderFeedVino(){
        return new Promise( resolve => {
            this.headerFeedVinoHeight = this.headerFeedVino.getBoundingClientRect().height
            this.headerFeedVinoWrapper = this.headerFeedVino.querySelector('.header-feed-vino__wrapper')               
            let duration = 0.4
            //Disattivato dopo che ho spostato l'header feed vino dentro all'header  
            // gsap.to(document.querySelector('header'),{
            //     duration,
            //     top: 0,
            //     ease: 'power1.out'
            // })
            gsap.to(this.headerFeedVinoWrapper, {
                duration,
                height: '0%',
                ease: 'power1.out',
                onComplete: () => {
                    gsap.set(this.headerFeedVino,{
                        y:'-100%'
                    })
                    resolve()
                }
            })
        })
    }
    apriHeaderFeedVino(){
        return new Promise( resolve => {
            this.headerFeedVinoHeight = this.headerFeedVino.getBoundingClientRect().height
            this.headerFeedVinoWrapper = this.headerFeedVino.querySelector('.header-feed-vino__wrapper')               
            let duration = 0.8
            gsap.set(this.headerFeedVino,{
                y:'0%'
            })
            //Disattivato dopo che ho spostato l'header feed vino dentro all'header  
            // gsap.to(document.querySelector('header'), {
            //     duration,
            //     top: this.headerFeedVinoHeight,
            //     ease: 'power1.out'
            // })
            gsap.to(this.headerFeedVinoWrapper, {
                duration,
                height: '100%',
                ease: 'power1.out',
                onComplete: () => {
                    resolve()
                }
            })
        })
    }

}

export {Header}